import React, { useEffect, useState } from 'react'
import UserRoutes from '../Common/UserRoutes'
import LoadingScreen from '../Common/LoadingScreen'
import Info from '../Common/Info'
import Verification from './Verification'

import { getUserBadge } from '../../store/actions/user'
import { connect } from 'react-redux'
import { copyToClipboard } from '../../utils/parseData'
var QRCode = require('qrcode.react');

function BadgeInfo({ getUserBadge, match, user }) {
  const { email, title, version } = match.params

  const [formObj, setFormObj] = useState({
    state: 'idle',
    email: email,
    title: title,
    version: version,
  })
  const [showVerification, setShowVerification] = useState(false)

  useEffect(() => {
    getUserBadge(formObj, setFormObj)
  }, [])

  const { state } = formObj
  const { userBadge, userBadgeError } = user
  const userName = email.split('@')[0].split('.')[0] + ' ' + email.split('@')[0].split('.')[1]
  const options = { year: 'numeric', month: 'long', day: 'numeric' }

  return (
    <UserRoutes user={email}>
      <div id='BadgeInfo'>
        {showVerification && (
          <Verification userBadge={userBadge} userName={email} setShowVerification={setShowVerification} />
        )}
        {state !== 'idle' && <LoadingScreen />}
        <Info messages={[...userBadgeError]} alertType='alert-danger' />
        {userBadgeError.length === 0 && userBadge && (
          <>
            <div className='row d-flex justify-content-around'>
              <div className='col-md-3 align-items-center badge-image d-flex flex-column '>
                <div>
                  <img src={`${process.env.REACT_APP_API_URI}${userBadge.imageURL}`} alt='' />
                </div>
                <div className='pt-4 meta-wrapper'>
                  <p>
                    <span className='meta-title'>Duration</span> - <span className='meta-desc'>{userBadge.time}</span>
                  </p>
                  <p>
                    <span className='meta-title'>Type</span> - <span className='meta-desc'>{userBadge.courseType}</span>
                  </p>
                  <p>
                    <span className='meta-title'>Level</span> - <span className='meta-desc'>{userBadge.levelType}</span>
                  </p>
                  <p>
                    <span className='meta-title'>Expiration</span> -{' '}
                    {userBadge.expirationDate !== 'never'
                      ? new Date(userBadge.expirationDate).toLocaleDateString('en-GB', options)
                      : 'Never'}
                  </p>
                  <p className='mt-4 issuance-meta'>
                    This badge was issued to <br />
                    <span className='meta-title'>{email}</span> on
                    <br />
                    <span className='issued-date'>
                      {new Date(userBadge.dateIssued).toLocaleDateString('en-GB', options)}
                    </span>
                  </p>
                </div>
                <div className='mt-4 w-100 row justify-content-center'>
                  <button className='actions me-3 mt-1' onClick={() => setShowVerification(true)}>
                    Verify
                  </button>
                  <button
                    className='actions me-3 mt-1'
                    onClick={() =>
                      copyToClipboard(
                        `${process.env.REACT_APP_API_URI}/badge-info/${userName}/${userBadge.title}/${userBadge.version}`
                      )
                    }>
                    Share
                  </button>
                </div>
                <div className="d-flex my-2 justify-content-start qr-code">
                  <QRCode value={`${process.env.REACT_APP_API_URI}/badge-info/${userName}/${userBadge.title}/${userBadge.version}`} />
                </div>
              </div>
              <div className='col-md-8 mt-md-0 mt-4 ps-3'>
                <div className='badge-title'>{userBadge.title}</div>
                <div className='mt-0'>
                  <span className='badge-issuer'>Issued by : {userBadge.issuedBy}</span>
                </div>
                <div className='mt-3'>{userBadge.description}</div>
                <div className='mt-5'>
                  <div className='section-title'>Skills</div>
                  <div className='d-flex justify-content-start row ps-2 '>
                    {userBadge.skills.map((element, i) => (
                      <div className='col-3 col-md-2 mt-2 me-2 py-2 text-center skills'>{element}</div>
                    ))}
                  </div>
                </div>
                <div className='mt-5'>
                  <div className='section-title'>Earning Criteria</div>
                  <ul className='px-3 pt-2 criteria'>
                    <li>{userBadge.criteria}</li>
                  </ul>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </UserRoutes>
  )
}

const mapStateToProps = ({ user }) => ({ user })
export default connect(mapStateToProps, { getUserBadge })(BadgeInfo)
